import { gql } from '../../../__generated__';

export const GET_IMAGE_SIGNED_URL =
  gql(`query GetImageSignedUrlWeb($data: GetImageSignedUrlWebInput) {
  getImageSignedUrlWeb(data: $data) {
    key
    signedUrl
  }
}
`);

export const VALIDATE_BASE_IMAGE = gql(`
  query ValidateBaseImageWeb($data: ValidateBaseImageWebInput) {
  validateBaseImageWeb(data: $data) {
    message
    success
  }
}
`);

export const GET_PROPERTY_TYPES = gql(`
  query GetAllPropertyTypesWeb {
  getAllPropertyTypesWeb {
    total
    data {
      propertyName
    }

  }
}
`);
